export const buttonStyle = {
    transition: 'all 0.2s ease-out',
    borderRadius: '10px',
    height: '35px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 25px',
    border: '2px solid white',
    color: 'white',
    backgroundColor: 'black',
}
export const buyButtonStyle = {
    color: 'black',
    textDecoration: 'none',
    border: 0,
    padding: '12px 12px',
    backgroundColor: 'primary.main',
    ':hover': {
        backgroundColor: 'primary.main',
    },
}
export const playButtonStyle = {
    backgroundColor: 'white',
    color: 'black',
    '& div > svg': {
        '& > path': {
            stroke: 'black',
        },
    },
    ':hover': {
        backgroundColor: 'white',
    },
}

export const iconStyle = {
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center',
}

export const favoriteButtonStyle = {
    ...buttonStyle,
    ...{
        padding: '8px',
        width: 'fit-content',
        minWidth: 'auto',
        backgroundColor: 'none',
    },
}
